(() => {
  const buttonSelector = '[data-collection-notify-me]';
  if (window.GalGonenCollectionNotify) {
    window.GalGonenCollectionNotify.refresh();
    return;
  }

  const variants = new WeakMap();
  const pending = new WeakSet();
  let queued = false;
  let opening = false;

  function getKbite() {
    const api = window.growConfig;
    if (!api?.stockWidget?.isEnabled || !window.growClient) return null;
    if (typeof api.addPopUp !== 'function' || typeof api.stockWidgetClicked !== 'function') return null;
    if (typeof api.setStockFulFilledVariantOptions !== 'function') return null;
    return api;
  }

  function popupReady(api) {
    const id = api.stockWidget.popupSelector;
    // These are the same popup and handlers used by Kbite's collection script.
    api.addPopUp(id, api.stockWidget.modalHtml);
    return Boolean(window.growCampaignPopUps?.[id] && document.getElementById(id));
  }

  function readVariant(card, button) {
    if (variants.has(card)) return variants.get(card);
    const selected = card.querySelector('variants-set [data-selected-variant-json]');
    if (selected) {
      try {
        return JSON.parse(selected.textContent);
      } catch {
        return null;
      }
    }
    return {
      id: Number(button.dataset.variantId),
      available: button.dataset.variantAvailable !== 'false'
    };
  }

  function allowedProduct(api, button) {
    let tags;
    try {
      tags = JSON.parse(button.dataset.productTags || '[]').map(tag => tag.toLowerCase());
    } catch {
      return false;
    }
    if (api.stockWidgetDoNotShowTag && tags.includes(api.stockWidgetDoNotShowTag)) return false;
    return !api.stockWidgetShowTag || tags.includes(api.stockWidgetShowTag);
  }

  function refreshCard(card, api, ready) {
    const button = card.querySelector(buttonSelector);
    const container = button?.closest('[data-collection-notify-container]');
    const original = card.querySelector('[data-collection-notify-original]');
    if (!container || !original) return;
    const variant = readVariant(card, button);
    const show = Boolean(ready && !pending.has(card) && variant?.id && variant.available === false && allowedProduct(api, button));
    if (variant?.id && button.dataset.variantId !== String(variant.id)) button.dataset.variantId = variant.id;
    if (original.hidden !== show) original.hidden = show;
    if (container.hidden === show) container.hidden = !show;
  }

  function refresh() {
    const api = getKbite();
    let ready = false;
    try {
      ready = Boolean(api && popupReady(api));
    } catch {
      // Keep the original purchase controls if the app is unavailable.
    }
    document.querySelectorAll('[data-product-card]').forEach(card => refreshCard(card, api, ready));
    return ready;
  }

  function scheduleRefresh() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      refresh();
    });
  }

  document.addEventListener('change', event => {
    const picker = event.target.closest('variants-set');
    const card = picker?.closest('[data-product-card]');
    if (!card?.querySelector(buttonSelector)) return;
    pending.add(card);
    refresh();
  }, true);

  document.addEventListener('theme:card-variant:updated', event => {
    const card = event.target.closest('[data-product-card]');
    if (!card) return;
    variants.set(card, event.detail.variant);
    pending.delete(card);
    scheduleRefresh();
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest(buttonSelector);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (opening || button.closest('[data-collection-notify-container]').hidden) return;
    const card = button.closest('[data-product-card]');
    const api = getKbite();
    const variant = readVariant(card, button);
    if (!api || pending.has(card) || variant?.available !== false || !allowedProduct(api, button)) {
      refresh();
      return;
    }

    const error = card.querySelector('[data-collection-notify-error]');
    error.hidden = true;
    opening = true;
    button.setAttribute('aria-busy', 'true');
    try {
      if (!popupReady(api)) throw new Error('Notification form is not ready');
      // Kbite updates the first matching trigger after subscribing; mark only this card.
      document.querySelectorAll(buttonSelector + '[gw-stock-fulfilled]').forEach(previous => previous.removeAttribute('gw-stock-fulfilled'));
      button.setAttribute('gw-stock-fulfilled', '');
      button.dataset.variantId = variant.id;
      // Kbite's click handler starts this request without awaiting it. Prepare the
      // new product first so the form cannot display another card's variants.
      api.clickedProductId = Number(button.dataset.productId);
      api.clickedProductHandle = button.dataset.productHandle;
      api.clickedVariantId = Number(variant.id);
      await api.setStockFulFilledVariantOptions();
      const current = readVariant(card, button);
      if (!button.isConnected || pending.has(card) || current?.id !== variant.id || current.available !== false) return;
      // Kbite reads event.target's data attributes, including clicks on nested text/icons.
      await api.stockWidgetClicked({ target: button });
    } catch {
      error.hidden = false;
    } finally {
      button.removeAttribute('aria-busy');
      opening = false;
    }
  }, true);

  const content = document.getElementById('MainContent');
  if (content) {
    new MutationObserver(scheduleRefresh).observe(content, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled']
    });
  }
  document.addEventListener('shopify:section:load', scheduleRefresh);
  window.GalGonenCollectionNotify = { refresh };

  // The app initializes asynchronously; leave Sold Out visible until its form is ready.
  let attempts = 0;
  const readinessTimer = setInterval(() => {
    if (refresh() || ++attempts >= 60) clearInterval(readinessTimer);
  }, 250);
  refresh();
})();
